import React from "react";
import { Navigate, BrowserRouter as Router } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import MainLayout from "./Components/Layout/MainLayout";
import Login from "./Components/Pages/Login/LogIn";
import ForgotPassword from "./Components/Pages/ForgotPassword/ForgotPassword";
import VerifyOtp from "./Components/Pages/ForgotPassword/VerifyOtp";
import ResetPassword from "./Components/Pages/ForgotPassword/ResetPassword";
import Registration from "./Components/Pages/Registration/Registration";
import TestRegister from "./Components/Pages/Registration/TestRegister";
import { useAuth } from "./Components/Context/store/context";
import Loader from "./Components/Pages/Loader/Loader";
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import WebsitePageForm from "./Components/Pages/WebsitePage/Website/WebsitePageForm";
import CreateUser from "./Components/Pages/WebsitePage/Website/CreateUser";
import Roll from "./Components/Pages/WebsitePage/Website/Roll";
import Package from "./Components/Pages/WebsitePage/Website/Package";
import Customer from "./Components/Pages/WebsitePage/Website/Customer";
import Reports from "./Components/Pages/WebsitePage/Website/Reports";
import Application from "./Components/Pages/WebsitePage/Website/Application";
import CustomerD from "./Components/Pages/WebsitePage/Website/CustomerD";
// handling loader
const LoaderWrapper = ({ children }) => {
  const { loading } = useAuth();

  return (
    <>
      {loading && <Loader />}
      {children}
    </>
  );
};

// main app
function App() {
  return (
    <>
      <LoaderWrapper>
        <Router>
          <Routes>
            {/* <Route path="/login" element={<Registration />} /> */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify" element={<VerifyOtp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/" element={<MainLayout />}>
              <Route path="" element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<WebsitePageForm />} />
              <Route path="CreateUser" element={<CreateUser />} />
              <Route path="Roll" element={<Roll />} />
              <Route path="Package" element={<Package />} />
              <Route path="Customer" element={<CustomerD />} />
              {/* <Route path="Customerview" element={<Customer />} /> */}
              <Route path="Reports" element={<Reports />} />
              <Route path="Application" element={<Application />} />
              <Route path="TestRegister" element={<TestRegister />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route path="/*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </LoaderWrapper>
      <div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          newestOnTop
          closeOnClick
          rtl={false}
          draggable={false}
          pauseOnFocusLoss={false}
          pauseOnHover
          theme="dark"
          transition={Slide} />
      </div>
    </>
  );
}
export default App;
